<template>
  <div id="boton-validaciones">
    <v-container grid-list-xl fluid>
      <v-flex lg12>
        <v-card>
          <boton-proceso-tab-validaciones
            :lstBtn="lstBtn"
          ></boton-proceso-tab-validaciones>
        </v-card>
        <div v-if="loading">
          <loading></loading>
        </div>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import Material from "vuetify/es5/util/colors";
import BotonProcesoTabValidaciones from "@/modules/configuration/commonsviews/BotonProcesoTabValidaciones.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "boton-validaciones",

  components: {
    MiniStatistic,
    BotonProcesoTabValidaciones,
    Loading,
  },
  data: () => ({
    color: Material,
    iconoBoton: "fa-print",
    tituloBoton: "Validaciones",
    colorBoton: "yellow darken-4",
    lstBtn: [],
    lstBtnCompleta: [
      {
        icon: "fa-print",
        title: "Infraestructura",
        subtitle: "",
        color: "yellow darken-3",
        class: "impresion rombo elevation-10",
        subPro: "Infraestructura", //valor para subproceso en BotonProcesoTabCapacitacion.vue
        tab: "Infraestructura", //valor para tab en BotonProcesoTabCapacitacion.vue
      },
      {
        icon: "all_inbox",
        title: "Validaciones",
        subtitle: "",
        color: "purple darken-2",
        class: "mecanizado rombo elevation-10",
        subPro: "Validaciones",
        tab: "Validaciones",
      },
      {
        icon: "business",
        title: "Administrativo",
        subtitle: "",
        color: "blue darken-3",
        class: "administrativo rombo elevation-10",
        subPro: "ADMINISTRATIVO",
        tab: "Administrativo",
      },
      {
        icon: "all_inbox",
        title: "Prod&Report",
        subtitle: "",
        color: "yellow darken-3",
        class: "prod rombo elevation-10",
        subPro: "REPORTES",
        tab: "Productos",
      },
    ],
  }),
  computed: {},
  Mounted() {},
  created() {
    this.loadDataPanelControl();
  },
  methods: {
    async loadDataPanelControl() {
      this.loading = true;
      let lstBtnTmp = await this.loadPanelControl();
      for (let i = 0; i < lstBtnTmp.length; i++) {
        // console.log("st::btn:" + i + "::" + JSON.stringify(lstBtnTmp[i], null, 2));
        this.lstBtn.push(this.lstBtnCompleta[lstBtnTmp[i] - 1]);
      }
      this.loading = false;
    },
    async loadPanelControl() {
      return await axios
        .get(
          "/panelControl/posicionActivos/" + this.$store.getters.contratoStored
        )
        .then(function (response) {
          // console.log('response  orden mosrar validaciones:' + response.data);
          return response.data;
        })
        .catch(function (error) {
          console.log("error loadPanelControl:" + error);
        });
    },
  },
};
</script>
